import React, { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';
import Toggle from '../Toggle';
import styles from './styles.module.scss';

export default function AppSwitch({
  state,
  onClick,
  text,
  extraClassName,
  description,
}) {
  const { themeColor } = useContext(AdminContext);
  return (
    <div className={`${styles.switchContainer} ${extraClassName} `}>
      <div
        className={`flex flex-row justify-between items-center w-full h-auto mb-[10px]`}
      >
        <div
          className={`flex flex-col justify-center items-start w-auto h-auto`}
        >
          <div className={`${styles.switchTitle} `}>{text}</div>
          <div className={`${styles.switchText} switchText`}>{description}</div>
        </div>
        <Toggle state={state} onClick={onClick} />
      </div>
    </div>
  );
}
